import { AssessmentStateEntry } from "@pandas/assessment-engine";
import { StateCreator } from "zustand";
import { LocalStorage } from "../index";

// INITIAL STATE
export type AssessmentInfoSlice = {
	functionalTestsUpdatedTimestamp: Date | null;
	assessmentEngineState: Array<AssessmentStateEntry>;
	setFunctionalTestsUpdatedTimestamp: (functionalTestsUpdatedTimestamp: Date | null) => void;
	setAssessmentEngineState: (state: Array<AssessmentStateEntry>) => void;
};

export const initialState = {
	functionalTestsUpdatedTimestamp: null,
	assessmentEngineState: [],
};

export const createAssessmentInfoSlice: StateCreator<
	LocalStorage,
	[],
	[
		[
			"zustand/persist",
			{
				functionalTestsUpdatedTimestamp: Date;
				assessmentEngineState: Array<AssessmentStateEntry>;
			},
		],
	],
	AssessmentInfoSlice
> = (set) => ({
	...initialState,
	setFunctionalTestsUpdatedTimestamp: (functionalTestsUpdatedTimestamp: Date | null) =>
		set(() => ({ functionalTestsUpdatedTimestamp: functionalTestsUpdatedTimestamp })),
	setAssessmentEngineState: (state: Array<AssessmentStateEntry>) =>
		set(() => ({
			assessmentEngineState: state,
		})),
});
